import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional class joiner : `clsx` semantics + tailwind conflict resolution.
 * Use everywhere classes are composed from multiple sources.
 *
 *   cn('btn', variant === 'primary' && 'primary', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
